
/**
 * Get a standardized description that removes any special characters and replaces spaces with dashes.
 * @param description       {String} The description of the product
 * @returns {String} returns a normalized product description for use on the URL.
 */
export function normalizeProductDescription(description) {
  return description
    .replace(/-/g,"") // Remove all dashes
    .replace(/ /g,"-") // Replace all spaces with dashes
    .replace(/---/g,"--") // Convert all 3 dashes to 2 dashes
    .replace(/[()./']/g,"") // Remove unncessary symbols.
    +"/"
}

/**
 * Get a standardized link to the product detail page. Almost always you will see
 * Insight's materialId is identical to the manufacturer's manufacturerPartNumber, but if two different
 * manufacturers have the same part number, then Insight's part number will be different to avoid assure
 * a unique id.
 * @param {{ materialId, manufacturerName, manufacturerPartNumber, description }}
 *  description             {String} The description of the product
 *  locale                  {String} The locale for the link path.
 *  materialId              {String} The Insight materialId (Insight ID of the product)
 *  manufacturerName        {String} The name of the manufacturer name
 *  manufacturerPartNumber  {String} The manufacturer part number (mfr ID of the product).
 * @returns {String}
 */

export default function getProductDetailLink({ description, locale, manufacturerName, manufacturerPartNumber, materialId }) {
  return "/"+locale+"/shop/product/"+
    encodeURIComponent(materialId)+"/"+
    encodeURIComponent(manufacturerName)+"/"+
    encodeURIComponent(manufacturerPartNumber)+"/"+
    normalizeProductDescription(description)
}
